export default {"src":"/_next/static/image/public/images/flags/flag_682.247251217cd4e5200e0d16d339f9ffc5.svg","height":16,"width":24};